import React from 'react';
import {Footer} from '../Components/Footer.js';
import Tushar from '../Images/Tushar.png';
import Indu from '../Images/Indu.jpg';
import Pranav from '../Images/Pranav.jpg';
import Aditya from '../Images/Aditya.jpg';

export const About = () => {
  return (
    <>
      {/* For Mobile Devices  */}
      <div className="lg:hidden">
        <div className='mt-6 mx-6 flex grow justify-center items-center'>
          <div className="bg-[#e2f6ff] w-11/12">
            <h2 className='font-bold text-center'>The team</h2>
          </div>
        </div>
        <div className='px-6 grid justify-center items-center'>
          {/* Tushar Info */}
          <div className='flex mx-2 my-4'>
            <img className='w-28 border-[0.01rem] border-black rounded drop-shadow-xl' src={Tushar} alt="" />
            <p className='ml-4'>Tushar is a studentprenuer from Chennai.
              He started 2 companies in the lockdown period,
              He is experienced in the domain of sales,
              business developement, marketing, and management.</p>
          </div>
          {/* Indu Info */}
          <div className='flex mx-2 my-4'>
            <img className='w-28 border-[0.01rem] border-black rounded shadow-lg' src={Indu} alt="" />
            <p className='ml-4'>Indu is a UI UX developer 
              with 9 projects in this domain.
              Also develops apps using flutter.</p>
          </div>
          {/* Pranav Info */}
          <div className='flex mx-2 my-4'>
            <img className='w-28 border-[0.01rem] border-black rounded shadow-lg' src={Pranav} alt="" />
            <p className='ml-4'>Pranav is a MERN Stack developer 
              with a ton of experience in website 
              dev and ops. Interned at various 
              organisations in the domains of 
              management as well.</p>
          </div>
          {/* Aditya Info */}
          <div className='flex mx-2 my-4'>
            <img className='w-28 border-[0.01rem] border-black rounded shadow-lg' src={Aditya} alt="" />
            <p className='ml-4'>Aditya is an experienced flutter developer. 
              He is part of numerous tech communities 
              and an avid coder. He has Worked in 
              multiple startups already. </p>
          </div>
        </div>
      </div>

      {/* For Desktop  */}
      <div className='hidden lg:block'>
        <div className='mt-6 mx-6 flex grow justify-center items-center'>
          <div className="flex flex-col justify-center items-center bg-[#e2f6ff] h-8 w-11/12">
            <h2 className='font-bold text-center'>The team</h2>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex flex-row mx-8 w-11/12">
            <img className='w-48 my-8 mx-16 border-[0.01rem] border-black rounded shadow-lg' src={Tushar} alt="" />
            <div className='mt-16 w-11/12'>
              <h2 className='text-xl font-bold'>Tushar Shah</h2>
              <div className='bg-[#e2f6ff] h-6 mt-2 w-11/12'>
                <p className='text-lg font-semibold text-[#0e719c]'>Founder and CEO</p>
              </div>
              <div className='flex flex-row grow w-4/5'>
                <p className='text-left'>Tushar is a studentprenuer from Chennai.
                He started 2 companies in the lockdown period,
                He is experienced in the domain of sales,
                business developement, marketing, and management.</p>  
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-between mb-20">
            {/* Pranav  */}
            <div className='mx-10 w-64'>
            <img className='w-48 my-8 mx-16 border-[0.01rem] border-black rounded shadow-lg' src={Pranav} alt="" />
              <p className='text-lg text-center font-semibold -pt-24 ml-12'>Pranav Mujumdar</p>
              <div className='bg-[#e2f6ff] ml-12 my-2'>
                <p className='text-md font-semibold text-[#0e719c] text-center'>Tech Head</p>
              </div>
              <div className='flex flex-row grow text-left ml-12'>
                <p className=''>Pranav is a MERN Stack developer 
                with a ton of experience in website 
                dev and ops. Interned at various 
                organisations in the domains of 
                management as well.</p>  
              </div>
            </div>
            {/* Indu  */}
            <div className='mx-10 w-64'>
            <img className='w-48 my-8 mx-10 border-[0.01rem] border-black rounded shadow-lg' src={Indu} alt="" />
              <p className='text-lg text-center font-semibold -pt-24 mx-12'>Indu Subramanian</p>
              <div className='bg-[#e2f6ff] mx-10 my-2'>
                <p className='text-md font-semibold text-[#0e719c] text-center'>Design Head</p>
              </div>
              <div className='flex flex-row grow text-left mx-12'>
                <p className=''>Indu is a UI UX developer 
                with 9 projects in this domain.
                Also develops apps using flutter.</p>  
              </div>
            </div>
            {/* Aditya  */}            
            <div className='mx-10 w-64'>
            <img className='w-48 my-8 mr-20 border-[0.01rem] border-black rounded shadow-lg' src={Aditya} alt="" />
              <p className='text-lg text-center font-semibold -pt-24 mr-20'>Aditya</p>
              <div className='bg-[#e2f6ff] mr-12 my-2'>
                <p className='text-md font-semibold text-[#0e719c] text-center'>Tech Head</p>
              </div>
              <div className='flex flex-row grow text-left mr-12'>
                <p className=''>Aditya is an experienced flutter developer. 
              He is part of numerous tech communities 
              and an avid coder. He has Worked in 
              multiple startups already.  </p>  
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}